import { colorHex } from '@/utils/colors'
import { getDataLayerCategory } from '@/utils/layers/dataLayers'
import {
  IBaseEffect,
  IDataLayer,
  IEffect,
  IEffectRemedy,
  IPillLinkItem,
  IPointRankingItem,
  IRemedy,
  IRemedyEffect
} from '@lifk/types'

// Typeguards for mapping function below
const isPartialRemedy = (
  item: IRemedy | IBaseEffect | IEffectRemedy | IRemedyEffect
): item is IRemedy | IEffectRemedy => {
  return (item as IRemedy | IEffectRemedy).stickerImg !== undefined
}

export const mapRemedyEffectToPillLinkItem = (
  item: IRemedy | IBaseEffect | IEffectRemedy | IRemedyEffect
): IPillLinkItem => {
  const defaultColor = colorHex('charcoal')
  const defaultTextColor = colorHex('white')
  return {
    linkType: isPartialRemedy(item) ? 'remedy' : 'effect',
    key: item.key,
    name: item.nameI18n,
    description: isPartialRemedy(item)
      ? item.descriptionI18n
      : (item as IEffect).definitionI18n,
    categoryName: item.category.name,
    budgets: isPartialRemedy(item) ? item.budgets : undefined,
    footprint: isPartialRemedy(item) ? item.footprint : undefined,
    footprintPlacement: isPartialRemedy(item)
      ? item.footprintPlacement
      : undefined,
    pillColor: item.category.categoryColor ?? defaultColor,
    textColor: item.category.categoryTextColor ?? defaultTextColor
  }
}

export const mapDataLayerToPillLinkItem = (
  dataLayer: IDataLayer
): IPillLinkItem => {
  const category = getDataLayerCategory(dataLayer)
  return {
    linkType: 'dataLayer',
    key: dataLayer.key,
    name: dataLayer.name,
    description: dataLayer.shortDescription,
    categoryName: category.name,
    pillColor: category.color,
    textColor: colorHex('charcoal'),
    dataLayer
  }
}

export const mapRemedyEffectToRankingItem = (
  item: IEffectRemedy | IRemedyEffect
): IPointRankingItem => {
  const pillLinkItem = mapRemedyEffectToPillLinkItem(item)
  return {
    ...pillLinkItem,
    level: item.level,
    points: item.points,
    icon: isPartialRemedy(item) ? item.stickerImg : undefined
  }
}
